// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"7c466f49","189":"4d148650","212":"2e4d1a2b","831":"85cc06da","882":"c9ef8dfd","965":"641b75dd"}[chunkId] + ".chunk.css";
};